import React from 'react';
import { get, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Select } from '@bd/bdui-forms';

function AreaSelectField({
  areas,
  className,
  field,
  label,
  placeholder,
  required,
  requiredMessage,
  getErrorClass,
  getError,
}) {
  return (
    <div className={className}>
      {
        label &&
        <label htmlFor={field}>
          {label}
          {
            required &&
            <span className="required"> *</span>
          }
        </label>
      }
      <Select
        className={`form-control ${getErrorClass(field)}`}
        name={field}
        field={field}
        placeholder={placeholder}
        validate={value => {
          let error = null;

          if (!error && required) {
            error = required && !value
              ? (requiredMessage || `${(label || '').replace(/[?!.*]/g, '')} is required.`)
              : null;
          }

          return error;
        }}
        options={
          orderBy(areas, 'name', 'asc')
          .map(area => ({ label: get(area, 'name'), value: get(area, 'name') }))
        }
      />
      <div className="invalid-feedback">
        {getError(field)}
      </div>
    </div>
  );
}

AreaSelectField.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  requiredMessage: PropTypes.string,
  getErrorClass: PropTypes.func.isRequired,
  getError: PropTypes.func.isRequired,
};

AreaSelectField.defaultProps = {
  className: undefined,
  label: undefined,
  placeholder: undefined,
  required: false,
  requiredMessage: undefined,
};

export default withData({
  areas: 'metros',
})(AreaSelectField);



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/AreaMetroSelect.js